import { useState } from "react";

const faqs = [
  {
    question: "福利导航上的资源是否全部免费？",
    answer: "大部分福利资源是免费的，包括电商优惠券、政府补贴政策、免费体检等。部分资源如会员权益可能需要满足一定条件才能享受，我们会在文章中详细说明使用条件。",
  },
  {
    question: "福利信息多久更新一次？",
    answer: "我们的编辑团队每日追踪各大平台的政策变化和优惠活动，确保信息的时效性。重大福利变动会在24小时内更新，常规内容每周全面核查一次。",
  },
  {
    question: "如何判断福利资源的真实性？",
    answer: "我们严格审核所有上线的福利资源，信息来源包括官方公告、品牌合作、用户反馈等多渠道验证。每篇文章都会标注信息来源，让您用得放心。",
  },
  {
    question: "可以在手机上使用福利导航吗？",
    answer: "福利导航网站完全适配手机端，您可以在任何设备上流畅浏览。建议将网站添加到手机桌面，方便随时查看最新福利信息。",
  },
  {
    question: "如何申请文章中提到的政府福利？",
    answer: "每篇涉及政府福利的文章都会详细说明申请条件、所需材料和办理流程。您可以根据指南在当地政务服务中心或线上政务平台办理。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于福利导航的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}